import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import Input from "../../../../ui/molecules/input"
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox"
import { GGNotificationCropCreation, resetCropCreationRequest, setCropCreationAddress, setCropCreationArea, setCropCreationCropType, setCropCreationDescription, setCropCreationDestinationCountry, setCropCreationGGNotificationId, setCropCreationHarvestingExclusion, setCropCreationHarvestingPeriod, setCropCreationHarvestingType, setCropCreationLatitude, setCropCreationLongitude, setCropCreationManipulation, setCropCreationManipulationType, setCropCreationOtherSubcontractedActivity, setCropCreationParallelProperty, setCropCreationProduct, setCropCreationSubcontractedManipulation } from "./slice"
import { CustomRadio } from "../../../../ui/molecules/radioButton"
import { CropTypeEnum, GGManipulationEnum, HarvestingTypeEnum } from "./dataservice/dto"
import Button from "../../../../ui/molecules/button"

interface Props {
    close: () => void
}

export function Option1Popup(props: Props) {
    const dispatch = useAppDispatch()
    const ggNotificationCropState = useAppSelector(state => state.ggNotificationCrop)
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const [harvestingExc, setHarvestingExc] = useState<boolean>(false)
    const [cropType, setCropType] = useState<string | null>(null)
    const [harvestingType, setHarvestingType] = useState<string | null>(null)
    const [manipulation, setManipulation] = useState<boolean>(false)
    const [parallelProperty, setParallelProperty] = useState<boolean>(false)
    const [manipulationType, setManipulationType] = useState<string | null>(null)

    useEffect(() => {
        dispatch(setCropCreationGGNotificationId(ggNotificationState.ggNotificationIdToUpdate))
    }, [])

    useEffect(() => {
        if(ggNotificationCropState.cropCreationStatus === 'successfully') {
            dispatch(resetCropCreationRequest())
            props.close()
        }
    }, [ggNotificationCropState.cropCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="text-left notify-subtitle pb-3">
                    Sito Produttivo
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Numero o descrizione'}
                            placeholder="Specifica numero o descrizione..."
                            value={ggNotificationCropState.cropCreationRequest.description}
                            onChangeText={(text) => dispatch(setCropCreationDescription(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Indirizzo'}
                            placeholder="Specifica indirizzo..."
                            value={ggNotificationCropState.cropCreationRequest.address}
                            onChangeText={(text) => dispatch(setCropCreationAddress(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Latitudine'}
                            placeholder="Specifica latitudine..."
                            value={ggNotificationCropState.cropCreationRequest.latitude}
                            onChangeText={(text) => dispatch(setCropCreationLatitude(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Longitudine'}
                            placeholder="Specifica longitudine..."
                            value={ggNotificationCropState.cropCreationRequest.longitude}
                            onChangeText={(text) => dispatch(setCropCreationLongitude(text))}
                        />
                    </div>
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Prodotto'}
                            placeholder="Specifica prodotto..."
                            value={ggNotificationCropState.cropCreationRequest.product}
                            onChangeText={(text) => dispatch(setCropCreationProduct(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Superficie (ettari)'}
                            placeholder="Specifica superficie..."
                            value={ggNotificationCropState.cropCreationRequest.area}
                            onChangeText={(text) => dispatch(setCropCreationArea(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Periodo Raccolta (mese - mese)'}
                            placeholder="Specifica periodo..."
                            value={ggNotificationCropState.cropCreationRequest.harvestingPeriod}
                            onChangeText={(text) => dispatch(setCropCreationHarvestingPeriod(text))}
                        />
                    </div>
                </div>

                <div className="pt-3 pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div className='text-left notify-text-bold'>
                        Raccolta (indicare no quando la raccolta è esclusa)
                    </div>
                    <SingleCheckbox
                        label=''
                        checked={harvestingExc}
                        setChecked={(value) => {
                            dispatch(setCropCreationHarvestingExclusion(value))
                            setHarvestingExc(value)
                        }}
                    />
                </div>

                <div className="pt-3" style={{ display: 'flex', gap: '72px', borderBottom: '1px solid #d9e6e8' }}>
                    <div className="mb-5" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <span className='notify-text-bold'>
                            Tipologia Coltura
                        </span>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: '1' }]}
                                selectedValue={cropType}
                                onChange={(value) => {
                                    setCropType(value)
                                    dispatch(setCropCreationCropType(CropTypeEnum.PROTETTA))
                                }}
                                id={'crop1'}
                                name={'crop1'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Protetta (P)</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: '2' }]}
                                selectedValue={cropType}
                                onChange={(value) => {
                                    setCropType(value)
                                    dispatch(setCropCreationCropType(CropTypeEnum.PIENO_CAMPO))
                                }}
                                id={'crop2'}
                                name={'crop2'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Pieno Campo (PC)</span>
                            </div>
                        </div>
                    </div>

                    <div className="mb-5" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <span className='notify-text-bold'>
                            Tipologia Raccolta
                        </span>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: '1' }]}
                                selectedValue={harvestingType}
                                onChange={(value) => {
                                    setHarvestingType(value)
                                    dispatch(setCropCreationHarvestingType(HarvestingTypeEnum.PRIMA))
                                }}
                                id={'harvest1'}
                                name={'harvest1'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Prima</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: '2' }]}
                                selectedValue={harvestingType}
                                onChange={(value) => {
                                    setHarvestingType(value)
                                    dispatch(setCropCreationHarvestingType(HarvestingTypeEnum.SECONDA))
                                }}
                                id={'harvest2'}
                                name={'harvest2'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Seconda</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-left notify-subtitle pb-3 pt-3">
                    Manipolazione
                </div>

                <div className="mb-3" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <span className='notify-text-bold'>
                        Tipologia Manipolazione
                    </span>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: '2' }]}
                            selectedValue={manipulationType}
                            onChange={(value) => {
                                setManipulationType(value)
                                dispatch(setCropCreationManipulationType(GGManipulationEnum.CAMPO))
                            }}
                            id={'man_type1'}
                            name={'man_type1'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>Campo</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: '1' }]}
                            selectedValue={manipulationType}
                            onChange={(value) => {
                                setManipulationType(value)
                                dispatch(setCropCreationManipulationType(GGManipulationEnum.MAGAZZINO))
                            }}
                            id={'man_type2'}
                            name={'man_type2'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>Magazzino</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: '3' }]}
                            selectedValue={manipulationType}
                            onChange={(value) => {
                                setManipulationType(value)
                                dispatch(setCropCreationManipulationType(GGManipulationEnum.CAMPO_E_MAGAZZINO))
                            }}
                            id={'man_type3'}
                            name={'man_type3'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>Campo e Magazzino</span>
                        </div>
                    </div>
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '12px' }}>
                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            Manipolazione
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={manipulation}
                            setChecked={(value) => {
                                dispatch(setCropCreationManipulation(value))
                                setManipulation(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            Proprietà Parallela
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={parallelProperty}
                            setChecked={(value) => {
                                dispatch(setCropCreationParallelProperty(value))
                                setParallelProperty(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Manipolazione subappaltata'}
                            placeholder="Specifica manipolazione..."
                            value={ggNotificationCropState.cropCreationRequest.subcontractedManipulation}
                            onChangeText={(text) => dispatch(setCropCreationSubcontractedManipulation(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Altre attività subappaltate'}
                            placeholder="Specifica altre attività..."
                            value={ggNotificationCropState.cropCreationRequest.otherSubcontractedActivity}
                            onChangeText={(text) => dispatch(setCropCreationOtherSubcontractedActivity(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Paese Destinazione'}
                            placeholder="Specifica paese destinazione..."
                            value={ggNotificationCropState.cropCreationRequest.destinationCountry}
                            onChangeText={(text) => dispatch(setCropCreationDestinationCountry(text))}
                        />
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        dispatch(resetCropCreationRequest())
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(GGNotificationCropCreation(ggNotificationCropState.cropCreationRequest))}
                    />
                </div>
            </div>
        </div>
    )
}